<template>
  <div :class="['ibox2', 'analytics-dashboard-content-box', 'analytics-dashboard-content-notitle']" :style="contentBoxStyles">
    <div class="ibox-content2 p-0">
      <div class="dashboard-analytics">
        <TabbedBox :class="{'tabbedbox-contentbox': true, 'tabbedbox-large': large}">
          <template v-slot:tablist>
            <slot name="tablist" />
            <li class="dashboard-link" v-if="link">
              <router-link :to="link">{{linkName}}</router-link>
            </li>
          </template>
          <template v-slot:tabcontent>
            <div>
              <slot name="commoncontent" />
            </div>
            <slot name="tabcontent" />
          </template>
        </TabbedBox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardTabbedContentBox',
  props: {
    link: String,
    linkName: String,
    gridWidth: Number,
    gridHeight: Number,
    large: Boolean
  },
  computed: {
    contentBoxStyles() {
      var styles = {}

      if(this.gridWidth) {
        styles.width = this.gridWidth + 'px'
        styles['max-width'] = this.gridHeight + 'px'
      }
      if(this.gridHeight) {
        styles.height = this.gridHeight + 'px'
        styles['max-height'] = this.gridHeight + 'px'
      }

      return styles
    }
  }
}
</script>